export default __webpack_public_path__ + "static/media/logo-large.d1c8e3b5.png";